const invalidClass = 'invalid';

/**
 * Check validation of single form field
 * @param {HTMLElement | Object} field - Form field element or event object.
 *
 * @returns {boolean}
 */
function checkValidation(input) {
    let valid = true;
    let val = '';
    const field = input.target ? input.target : input;

    field.classList.remove(invalidClass);

    switch (field.nodeName) {
        case 'INPUT':
        case 'TEXTAREA':
        case 'SELECT':
        default:
            val = field.value;
            break;
    }

    if (field.type == 'checkbox' && !field.checked || val.trim() == '') {
        valid = false;
        field.classList.add(invalidClass);
        field.focus();
    }

    return valid;
}

/**
 * Runs [required] fields within form through validation function
 *
 * @param {HTMLElement} form - Form element to validate  *
 * @returns {boolean}
 */
export function validateForm(form) {
    const requiredFields = form.querySelectorAll('[required]');
    let valid = true;

    for (let i = 0; i < requiredFields.length; i++) {
        const field = requiredFields[i];

        valid = checkValidation(field);
        if (!valid) {
            break;
        }

    }

    return valid;
}

/**
 * This is ment as an 'input' eventhandler set on textareas,
 * to auto increase it's height depending on the users text-input.
 */
function textAreaAutoHeight() {
    this.style.height = ''; // Resets height, in case text is removed
    this.style.height = `${this.scrollHeight}px`;
}

/**
 * Simply adds a class to target field if it has a value and removes it if not.
 *
 * @param {Object || HTMLElement} e - Event or field element
 */
function checkFieldValue(e) {
    const field = e.target || e;
    field.value ? field.classList.add('has-text') : field.classList.remove('has-text');
}

/**
 * Sets up 'change'-eventhandler as checkValidation on given fields
 *
 * @param {HTMLElement} form - Form fields to validate
 */

export function watchFormFields(selector = 'form[data-action*="form"]') {
    const form = document.body.querySelectorAll(selector);

    if (form) {
        for (let f = 0; f < form.length; f++) {
            const fields = form[f].querySelectorAll('input, select, textarea');

            for (let i = 0; i < fields.length; i++) {
                const field = fields[i];
                field.addEventListener('keyup', checkFieldValue);

                if (field.hasAttribute('required')) {
                    field.addEventListener('change', checkValidation);
                }

                if (field.type == 'textarea') {
                    field.addEventListener('input', textAreaAutoHeight);
                }
            }
        }
    }
}

/**
 * Serializes form fields
 *
 * @param {HTMLElement} form - Form element to serialize  *
 * @returns {string} - Returns querystring of fields names and values
 */
export function serialize(form) {
    if (!form || form.nodeName !== 'FORM') {
        return;
    }
    let i, j;
    const q = [];
    for (i = form.elements.length - 1; i >= 0; i = i - 1) {
        if (form.elements[i].name === '') {
            continue;
        }
        switch (form.elements[i].nodeName) {
            case 'INPUT':
                switch (form.elements[i].type) {
                    case 'text':
                    case 'tel':
                    case 'email':
                    case 'date':
                    case 'number':
                    case 'hidden':
                    case 'password':
                    case 'button':
                    case 'reset':
                    case 'submit':
                        q.push(`${form.elements[i].name}=${encodeURIComponent(form.elements[i].value)}`);
                        break;
                    case 'checkbox':
                    case 'radio':
                        if (form.elements[i].checked) {
                            q.push(`${form.elements[i].name}=${encodeURIComponent(form.elements[i].value)}`);
                        }
                        break;
                    case 'file':
                        break;
                }
                break;
            case 'TEXTAREA':
                q.push(`${form.elements[i].name}=${encodeURIComponent(form.elements[i].value)}`);
                break;
            case 'SELECT':
                switch (form.elements[i].type) {
                    case 'select-one':
                        q.push(`${form.elements[i].name}=${encodeURIComponent(form.elements[i].value)}`);
                        break;
                    case 'select-multiple':
                        for (j = form.elements[i].options.length - 1; j >= 0; j = j - 1) {
                            if (form.elements[i].options[j].selected) {
                                q.push(
                                    `${form.elements[i].name}=${encodeURIComponent(form.elements[i].options[j].value)}`
                                );
                            }
                        }
                        break;
                }
                break;
            case 'BUTTON':
                switch (form.elements[i].type) {
                    case 'reset':
                    case 'submit':
                    case 'button':
                        q.push(`${form.elements[i].name}=${encodeURIComponent(form.elements[i].value)}`);
                        break;
                }
                break;
        }
    }
    return q.join('&').replace(/%20/g, '+');
}